import { render } from "./ArrayListElement.vue?vue&type=template&id=620f5bd6&ts=true"
import script from "./ArrayListElement.vue?vue&type=script&lang=ts"
export * from "./ArrayListElement.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__